import { useTranslation } from "react-i18next";

const CalculationMessage = (props) => {
    const { t } = useTranslation();
    if (!props.error) {
        return null;
    }

    return (
        <div className="alert alert-danger">
            <ul className="errorList">
                {
                    props.error.map(
                        e =>
                            <li key={e}>{t('booking.calculation.errors.' + e)}</li>
                    )
                }
            </ul>
        </div>
    );
};

export default CalculationMessage;